<template>
  <div class="content background1">
    <div class="tableBox9">
      <div class="tableMes">
        <div class="table">
          <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
            <el-tab-pane label="设备类型" name="first">
              <tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
            </el-tab-pane>
            <el-tab-pane label="所属区域" name="second">
              <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="tableBox10">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title"><span class="spot">{{deviceDetailMes.name}}</span>{{ $t('label_272') }}</p>
            <div class="chooseBox spaceBetween">
              <div class="selectBox">
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 70px;">
                      <p>设备名称</p>
                    </div>
                    <div class="select" style="width: 200px">
                      <el-input ></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose">
                    <div class="selectText">
                      <p>技改日期</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-date-picker v-model="Readytime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" :range-separator="$t('label_264')" :start-placeholder="$t('label_329')"
                                      :end-placeholder="$t('label_388')">
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttonBox">
                <div>
                  <div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>查询</div>
                </div>
              </div>
            </div>
            <div class="spotMes3Box">
              <div class="tableMin" style="height: 100%;">
                <div class="tableList" style="height: 100%;">
<!--                  <div class="buttonBox" style="float: left">-->
<!--                    <div>-->
<!--                      <div class="chooseButton searchButton" @click="excel" v-if="MenuRoleList.indexOf('43')>=0"><i class="el-icon-download"></i>导出</div>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="tableNum">
                    <p class="p4" style="width: 18%"><i class="el-icon-edit-outline" style="color: #3FB393"></i>
                      {{statusNumList.statusAll}}</p>
                    <p class="p4" style="width: 18%"><i class="el-icon-date" style="color: #3FB393"></i>
                      {{statusNumList.status2}}</p>
                    <p class="p4" style="width: 18%"><i class="el-icon-folder-checked" style="color: #3FB393"></i>{{statusNumList.status3}}</p>
                    <p class="p4" style="width: 18%"><i class="el-icon-document-copy" style="color: #3FB393"></i>
                      {{statusNumList.status4}}</p>
                  </div>
                  <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTreeTime"
                            border style="width: 100%;margin: 10px" height="88%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
                            @row-click="handler">
                    <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
                    </el-table-column>
                    <el-table-column prop="ename" label="设备名称" align="center" width="200">
                      <template slot-scope="scope">
                        <p class="tableMiTitle">
                          {{scope.row.superior}}<br>
                          {{scope.row.etname}} {{scope.row.ename}}<br>
                          {{scope.row.code}}
                        </p>
                      </template>
                    </el-table-column>
                    <el-table-column prop="numAll" label="已申请" align="center">
                    </el-table-column>
                    <el-table-column prop="num2" label="技改中" align="center">
                    </el-table-column>
                    <el-table-column prop="num3" label="验收中" align="center">
                    </el-table-column>
                    <el-table-column prop="num4" label="已完成" align="center">
                    </el-table-column>
                  </el-table>
                  <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                        @parentMethod="search"></Page>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import "@/assets/css/common/spot.css"
import Page from "@/components/common/page";
import TimePage from "@/assets/js/timePage/timePage.js";
import utils from '@/utils/utils'
import tree from "@/components/list/tree/checkTree";
import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
export default {
  name: 'transformationStatistics',
  components: {
    Page,
    tree,
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      Readytime: '',
      getTreeMes: '1',
      height: '',
      MenuRoleList: [],
      treeData: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '2'
      },
      treeData2: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '3'
      },
      deviceDetailMes: {},
      tableDataTreeTime: [],
      activeNameTree: 'first',
      statusNumList: [],
      id: '',
    }
  },
  methods: {
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    handler(row) {
      this.id = row.equipmentId;
    },
    handleClose() {
      this.dialogDeviceSpot = false;
      this.dialogSpotResult = false;
      this.dialogSpotBatchTimeEdit = false;
    },
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    handleCurrentChangeTreeTime(info) {},
    handleClickTree(tab, event) {
      this.getTreeMes = '1';
      this.deviceDetailMes = {};
      this.search({
        pageNum: 1,
        pageSize: this.pageSize,
      });
    },
    search(param) {
      // this.Readytime = ["2021-12-01T05:49:18.184Z", "2022-01-23T05:49:18.184Z", ]
      var dataParam = {
        beginTime: this.Readytime[0],
        endTime: this.Readytime[1],
        code: this.code,
        type: this.deviceDetailMes.type,
        id: this.deviceDetailMes.id,
      }
      var newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      this.searchPage(newParam);
      this.searchStauts(newParam);
    },
    searchPage(param) {
      SpotCheck.getCheckCount(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableDataTreeTime = data.data.records
          // for (var q = 0; q < this.tableDataTreeTime.length; q++) {
          // 	this.tableDataTreeTime[q].tName = '';
          // 	this.tableDataTreeTime[q].dName = '';
          // 	for (var i = this.tableDataTreeTime[q].typeName.length - 2; i >= 0; i--) {
          // 		this.tableDataTreeTime[q].tName += this.tableDataTreeTime[q].typeName[i] + ' ';
          // 	}
          // 	this.tableDataTreeTime[q].tName += this.tableDataTreeTime[q].typeName[this.tableDataTreeTime[q].typeName.length - 1]
          // 	for (var i = this.tableDataTreeTime[q].deptName.length - 1; i >= 0; i--) {
          // 		this.tableDataTreeTime[q].dName += this.tableDataTreeTime[q].deptName[i] + ' ';
          // 	}
          // }
          this.pageSize = data.data.size;
          this.pageCount = data.data.total;
          this.pageNum = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNum);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    searchStauts(param) {
      SpotCheck.getCheckStatus2(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.statusNumList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    excel() {
      if (this.id != '' && this.id != null) {
        window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentCheckRecord/excel?time=' + this.Readytime[0]
          .substring(0, 7) + "&id=" + this.id;
      } else {
        utils.messageAlert("请选择要导出的设备", this.$t('label_358'), this.$t('label_100'));
      }

    },
    getDeviceMes(data) {
      if (data.name == this.$t('label_272')) {
        this.deviceDetailMes = {};
        this.search({
          pageNum: 1,
          pageSize: this.pageSize,
        });
      } else {
        this.deviceDetailMes = data;
        this.search({
          pageNum: 1,
          pageSize: this.pageSize,
        });
      }
    },
    getNowTime() {
      let zeroTime = new Date();
      let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
      let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
      let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
      return now;
    },
    getBeforeTime() {
      var time = (new Date).getTime() + 24 * 60 * 60 * 1000;
      let zeroTime = new Date(time);
      let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
      let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
      let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates ;
      return now;
    },
  },
  created() {
    this.Readytime = [this.getNowTime(),this.getBeforeTime()]
    this.search({
      pageNum: 1,
      pageSize: this.pageSize
    });
    this.MenuRoleList = this.$store.getters.getMenu;
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/transformationAdmin/transformationStatistics.vue